// src/context/TourContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { useMutation } from "@apollo/client";
import { gql } from "@apollo/client";

const UPDATE_FIRST_TIME = gql`
  mutation UpdateFirstTime($userId: Int!) {
    updateFirstTime(userId: $userId, isFirstTime: 0) {
      success
    }
  }
`;

const TourContext = createContext();

export const TourProvider = ({ children }) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken") || "{}");
  const userId = parseInt(decodedToken.Id);
  const isFirstTime = decodedToken.isFirstTimeUser === "1"; // Check string "1"

  // Define all pages that have tours
  const tourPages = [
    "/dashboard",
    "/rights",
    "/users",
    "/module",
    "/performance-dashboard"
    // Add other routes from App.js as needed
  ];

  // Load toured pages from LocalStorage
  const [touredPages, setTouredPages] = useState(() => {
    const saved = localStorage.getItem(`touredPages_${userId}`);
    return saved ? JSON.parse(saved) : [];
  });

  const [updateFirstTime] = useMutation(UPDATE_FIRST_TIME);

  // Update LocalStorage when touredPages changes
  useEffect(() => {
    localStorage.setItem(`touredPages_${userId}`, JSON.stringify(touredPages));
    // Check if all pages are toured
    if (isFirstTime && touredPages.length === tourPages.length) {
      updateFirstTime({ variables: { userId } })
        .then(() => console.log("isFirstTime updated to 0"))
        .catch((err) => console.error("Error updating isFirstTime:", err));
    }
  }, [touredPages, userId, isFirstTime, updateFirstTime]);

  const markPageAsToured = (page) => {
    if (!touredPages.includes(page)) {
      setTouredPages([...touredPages, page]);
    }
  };

  const resetTour = () => {
    setTouredPages([]);
    localStorage.removeItem(`touredPages_${userId}`);
  };

  return (
    <TourContext.Provider
      value={{
        isFirstTime,
        touredPages,
        tourPages,
        markPageAsToured,
        resetTour,
      }}
    >
      {children}
    </TourContext.Provider>
  );
};

export const useTour = () => useContext(TourContext);